/** Shared CREATE YOUR PLAN wizard presentation helpers (preview design). */

import { FaBriefcase, FaHome, FaHotel, FaMapMarkerAlt } from 'react-icons/fa';

export const BUILDER_SPECIALTY_THEME = {
  general: { id: 'general', color: '#c45c26', soft: '#fff4ec', name: 'General' },
  gym: { id: 'gym', color: '#1b6b93', soft: '#e8f4fa', name: 'Gym' },
  diabetic: { id: 'diabetic', color: '#2e7d32', soft: '#eaf6ea', name: 'Diabetic' },
  weightloss: { id: 'weightloss', color: '#6b3fa0', soft: '#f3ebfa', name: 'Weight Loss' },
};

export const BUILDER_SLOT_SHORT_NAME = {
  breakfast: 'Breakfast',
  mid_morning: 'Mid-morn',
  lunch: 'Lunch',
  evening_snack: 'Evening',
  dinner: 'Dinner',
  full_day: 'Full Day',
};

export const BUILDER_PLAN_CARD_COPY = {
  days_3: { title: '3+ days', note: 'Minimum plan' },
  days_7: { title: '7+ days', note: 'One week or more' },
  days_15: { title: '15+ days', note: 'Two weeks or more' },
  days_30: { title: '30+ days', note: 'A month or more' },
  // Legacy month ids (older drafts / landing cards)
  1: { title: '1 month', note: '30 days' },
  2: { title: '2 months', note: '60 days' },
  3: { title: '3 months', note: '90 days' },
  4: { title: 'Custom', note: 'Pick your dates' },
};

export function resolveBuilderSpecialtyTheme(planId) {
  const raw = String(planId || '').toLowerCase().replace(/[\s_-]/g, '');
  if (raw.includes('gym')) return BUILDER_SPECIALTY_THEME.gym;
  if (raw.includes('diabetic')) return BUILDER_SPECIALTY_THEME.diabetic;
  if (raw.includes('weight')) return BUILDER_SPECIALTY_THEME.weightloss;
  return BUILDER_SPECIALTY_THEME.general;
}

export function builderCuisineLabel(regionKey) {
  const key = String(regionKey || '').toLowerCase();
  if (key === 'north') return 'North Indian';
  if (key === 'south') return 'South Indian';
  return regionKey ? String(regionKey) : '';
}

export const BUILDER_ADDRESS_TYPES = [
  { value: 0, label: 'Home', icon: FaHome },
  { value: 1, label: 'Work', icon: FaBriefcase },
  { value: 2, label: 'Hotel', icon: FaHotel },
  { value: 3, label: 'Other', icon: FaMapMarkerAlt },
];

export function builderAddressTypeMeta(type) {
  return BUILDER_ADDRESS_TYPES.find((item) => item.value === Number(type)) || BUILDER_ADDRESS_TYPES[3];
}

export function formatSavedAddressCard(address) {
  if (!address || typeof address !== 'object') {
    return { label: 'Address', line: '', city: '', pincode: '', type: 3 };
  }
  const typeMeta = builderAddressTypeMeta(address.type);
  return {
    label: address.name || typeMeta.label,
    line: address.address || '',
    city: [address.city, address.state].filter(Boolean).join(', '),
    pincode: address.postalCode || '',
    type: typeMeta.value,
  };
}
